'use strict'

var Type = require('../type')

module.exports = Type({
  name: 'American Express',
  pattern: /^3[47]\d{13}$/,
  eagerPattern: /^3[47]/,
  groupPattern: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
  cvcLength: 4
})



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/creditcards-types/types/american-express.js
// module id = 70Y0
// module chunks = 0